import { FilterCollection } from '../../../view/filters/models/FilterCollection';

export class NewbuildingFilterCollection extends FilterCollection {
    rebuild() {
        return new NewbuildingFilterCollection(this._filters);
    }
}
